import { FormGroup } from '@angular/forms';

// custom validator to check that two fields match
export function MatchValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup): void => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        if (matchingControl.errors && !matchingControl.errors.match) {
            // return if another validator has already found an error on the matchingControl
            return;
        }

        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ match: true });
        } else {
            matchingControl.setErrors(null);
        }
    };
}

export const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}$/;
